import { FileText, ListChecks } from "lucide-react";

// Estado de entrada: no se monta ningún informe hasta que se elige la selección.
export function ReportEmptyState({ onOpenSelector }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 px-6 py-12 text-center">
      <div className="w-12 h-12 mx-auto rounded-full bg-indigo-50 flex items-center justify-center">
        <FileText size={24} className="text-indigo-600" />
      </div>
      <h2 className="mt-4 font-semibold text-gray-900">
        Informe de respuestas
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        Elige las preguntas de las que quieres generar el informe.
      </p>
      <button
        onClick={onOpenSelector}
        className="mt-5 inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors"
      >
        <ListChecks size={16} />
        Seleccionar preguntas
      </button>
    </div>
  );
}

// Refleja la forma del estado de entrada, no la de un informe montado.
export function ReportSkeleton() {
  return (
    <div className="animate-pulse space-y-4">
      <div className="h-8 w-64 bg-gray-200 rounded" />
      <div className="h-64 bg-gray-200 rounded-xl" />
    </div>
  );
}

export function ReportError({ onRetry }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 px-4 py-8 text-center">
      <p className="text-sm text-gray-600">
        No se pudieron cargar los datos del informe.
      </p>
      <button
        onClick={onRetry}
        className="mt-3 px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors"
      >
        Reintentar
      </button>
    </div>
  );
}
